import { SelectOptionType } from "@aidkitorg/component-library";
import { useLocalizedStrings } from "../../../Localization";

export const useAggregationOptions = () => {
  const L = useLocalizedStrings();

  const AGGREGATION_OPTIONS: SelectOptionType[] = [
    { value: "Count", label: L.admin_panel.dashboards.count },
    { value: "Sum", label: L.admin_panel.dashboards.sum },
    { value: "Mean", label: L.admin_panel.dashboards.average },
  ]

  const getAggregationOption = (value: string) =>
    AGGREGATION_OPTIONS.find((v) => v.value === value)

  return {
    aggregationOptions: AGGREGATION_OPTIONS,
    getAggregationOption
  }
}